import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';


@Component({
  selector: 'app-pii-use-case-ai-ml-blog',
  templateUrl: './pii-use-case-ai-ml-blog.component.html',
  styleUrls: ['./pii-use-case-ai-ml-blog.component.css']
})
export class PiiUseCaseAiMlBlogComponent implements OnInit {

 baseUrl=Constants.baseUrl;
 isBrowser:boolean=false;


  constructor(  private titleService: Title, @Inject(PLATFORM_ID) private platformId: any,
  private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta,private viewportScroller: ViewportScroller) {
  
      this.isBrowser=isPlatformBrowser(this.platformId);
  }
  ngOnInit() :void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/application-services/"
  },
  "headline": "Application Services",
  "description": "Our next-generation application development service empowers some of the world's most successful businesses to streamline complex operations.",
  "image": "https://mitresource.com/assets/images/application/application-bulidimage.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-06-25"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    if(this.isBrowser){     
 AOS.init({disable: 'mobile'});
}

    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });

    }
    this.viewportScroller.scrollToAnchor(sectionId);

  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Client Story: Protecting Personal Identifiable Information (PII) using AI/ML');
    this.metaService.addTags([
      { name: 'description', content: 'The financial services industry operates and deals with vast amount of confidential client and customer data for daily business transactions!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Client Story: Protecting Personal Identifiable Information (PII) using AI/ML' },
      { property: 'og:url', content: 'https://mitresource.com/pii-use-case-ai-ml/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/pii-banner-image.png' },
      { property: 'og:description', content: 'The financial services industry operates and deals with vast amount of confidential client and customer data for daily business transactions.' },
    ]);
  }

  imageItems1 = [
    { src: "../../../assets/images/blogs/pii-blog1.png"  }
  ];

  imageItems2 = [
    { src: "../../../assets/images/blogs/pii-blog22.png"  }
  ]

  enlargedImageSrc: string | null = null;
  isEnlargedVisible = false;
  currentIndex = 0;
  currentImageList: 'imageItems1' | 'imageItems2'  = 'imageItems1';

  showEnlargedImage(src: string): void {
    this.enlargedImageSrc = src;
    this.currentIndex = (this[this.currentImageList] as Array<{ src: string }>)
      .findIndex(item => item.src === src);
    this.isEnlargedVisible = true;
  }

  hideEnlargedImage(): void {
    this.isEnlargedVisible = false;
  }

  prevImage(): void {
    const currentList = this[this.currentImageList] as Array<{ src: string }>;
    if (currentList.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + currentList.length) % currentList.length;
      this.enlargedImageSrc = currentList[this.currentIndex].src;
    }
  }

  nextImage(): void {
    const currentList = this[this.currentImageList] as Array<{ src: string }>;
    if (currentList.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % currentList.length;
      this.enlargedImageSrc = currentList[this.currentIndex].src;
    }
  }

  setCurrentImageList(list: 'imageItems1' | 'imageItems2' ): void {
    this.currentImageList = list;
    this.enlargedImageSrc = null; 
    this.isEnlargedVisible = false; 
  }
    
}
